import React from 'react';
import PropTypes from 'prop-types';

import TaskTypeIcon from 'core/gd-components/icons/task-icon/task-icon';
import SelectUser from "core/gd-ui/select-user/select-user";
import FormError from 'src/core/gd-form/common/form-error/form-error';

export default class ReassignUserTasks extends React.Component {
    static propTypes = {
        form: PropTypes.object,

        projectId: PropTypes.string,
        userId: PropTypes.string,
        tasks: PropTypes.array,
    };

    renderTasksList = () => {
        const tasksGroupedByProject = _.chain(this.props.tasks)
                .groupBy('projectId')
                .toPairs()
                .map((g)=>{
                    const project = gd.session.projects.get(g[0]);
                    return {
                        'projectId': g[0],
                        'projectName': project ? project.name : "0",
                        'items': _.sortBy(g[1],i=>i.title.toLowerCase())
                    };
                })
                .sortBy('projectName')
                .value();

        let tasksRes = [];
        if (tasksGroupedByProject) {
            tasksGroupedByProject.map(group=>{
                const project = gd.session.projects.get(group.projectId);
                group.items.map((t,key)=>{
                    const taskType = gd.session.taskTypes.get(t.taskTypeId);

                    tasksRes.push(
                        <div key={t.id} className="row">
                            <div className="cell">
                                {taskType && <TaskTypeIcon className="ui5-ico-13 m-r-10" icon={taskType.icon} hint={false}/>}
                                <div className="ui5-txt-default max-w-300">{t.title}</div>
                            </div>
                            <div className="cell align-r">
                                {/*<div className="ui5-property">{project.name}</div>*/}
                            </div>
                        </div>
                    )
                });
            })
        }

        // const userOptions = gd.session.projectUsers.filterByProject(this.props.projectId).exportToArrayUserId();
        const userOptions = gd.session.projectUsers.filterByProjectNotReadOnly(this.props.projectId).exportToArrayUserId();
        _.remove(userOptions, o=>o === this.props.userId);

        return (
            <React.Fragment>
                <div className="ui5-list h-40">
                    {tasksRes}
                </div>

                <div className="ra-to">
                    <div className="lbl">Re-assign to:</div>
                    <SelectUser form={this.props.form}
                                name="tasksReassignTo"
                                renderValue="form-icon-name"
                                options={userOptions} />
                    <div className="lbl"/>
                </div>

                <FormError className="block-error" form={this.props.form} name="tasksReassignTo" />
            </React.Fragment>
        )
    };

    render() {

        if (!this.props.tasks || this.props.tasks.length < 1) return false;

        return (
            <div className="block">
                <div className="ui5-title-small m-t-20 m-b-10">
                    Tasks
                </div>
                {this.renderTasksList()}
            </div>
        )
    }
}